import React, { Component } from "react";
import { withRouter } from "react-router";


class ModalComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showModal: props.show,
            zIndex: props.zIndex
        };
    }

    render() {
        const {showModal, zIndex} = this.state;
        return (
            <div className="modal fade show" id="modal-medium" tabIndex={-1} style={{ display: showModal ? 'block' : 'none', paddingRight: '16px', zIndex: zIndex  }}>
                <div className="modal-dialog modal-dialog-md modal-dialog-centered">
                    <div className="modal-content">
                        <a onClick={() => this.props.closeModal()} className="modal-close" data-dismiss="modal" aria-label="Close"><em className="ti ti-close" /></a>
                        <div className="popup-body">
                            <h3 className="popup-title">{this.props.title}</h3>
                            <div>{this.props.children}</div>
                        </div>
                    </div>
                    {/* .modal-content */}
                </div>
                {/* .modal-dialog */}
            </div>
        );
    }
}

export default withRouter(ModalComponent);
